// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-1f84b408] {\n  height: 100%;\n}\n.form-container[data-v-1f84b408] {\n  width: 100%;\n  height: calc(100% - 90px);\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.footer[data-v-1f84b408] {\n  width: 100%;\n  padding: 5px 0;\n  background-color: #fff;\n  border-top: 1px solid #eeefee;\n  z-index: 20000;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
